import React, { useRef, useEffect } from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import Message from './Message';
import styles from './MessageList.module.css';

function showDateSeparator(messages, index) {
  if (index === 0) return false;
  const curr = new Date(messages[index].ts);
  const prev = new Date(messages[index - 1].ts);
  return (
    curr.getDate() !== prev.getDate() ||
    curr.getMonth() !== prev.getMonth() ||
    curr.getFullYear() !== prev.getFullYear()
  );
}

function isConsecutive(messages, index) {
  if (index === 0) return false;
  const curr = messages[index];
  const prev = messages[index - 1];
  return curr.name === prev.name && (new Date(curr.ts) - new Date(prev.ts)) < 120000;
}

function formatDate(ts) {
  const d = new Date(ts);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (d.toDateString() === today.toDateString()) return 'Today';
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday';
  return d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });
}

export default function MessageList({ messages, currentUser }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (!messages.length) {
    return (
      <div className={styles.messageList}>
        <div className={styles.emptyState}>
          <FiMessageSquare className={styles.emptyIcon} />
          <p className={styles.emptyText}>No messages yet</p>
          <p className={styles.emptyHint}>Be the first to say something!</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.messageList}>
      {messages.map((msg, i) => (
        <React.Fragment key={i}>
          {showDateSeparator(messages, i) && (
            <div className={styles.dateSep}>
              <span>{formatDate(msg.ts)}</span>
            </div>
          )}
          <Message
            message={msg}
            isCurrentUser={msg.name === currentUser}
            isConsecutive={isConsecutive(messages, i)}
          />
        </React.Fragment>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
